import MediaQuery from 'react-responsive';
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import Popup from '../Popup';
import Button from '../../Button';
import FieldsList from '../FieldsList';
import { BREAKPOINT, COLORS } from '../../../constants/styles';
import { useSimpleForm } from './utils/useSimpleForm';
import { enhance } from './enhance';

const SimpleFormPopup = ({
  loading,
  onClose,
  onSubmit,
  title,
  onChange,
  description,
  submitBtnText,
  errors,
  fields,
  initialData,
  validateFields,
  customRoleOptions,
  intl: { formatMessage },
  secondaryContentVisible,
  strictClose,
  handleFieldOptions,
  mobileFullScreen,
  popupWidthType,
}) => {
  const {
    handleFormChange,
    validateErrors,
    clearErrors,
    formState,
    isValid,
  } = useSimpleForm(fields, validateFields || fields, errors, initialData);

  useEffect(() => {
    onChange(formState);
  }, [formState]);

  const handleSubmit = e => {
    e.preventDefault();
    clearErrors();
    onSubmit(formState);
  };

  return (
    <MediaQuery maxWidth={BREAKPOINT}>
      {isMobile => (
        <Popup
          mobileFullScreen={mobileFullScreen}
          opened
          onClose={onClose}
          title={title}
          width={popupWidthType || (isMobile ? 'medium' : 'small')}
          overflowVisible
          strictClose={strictClose || secondaryContentVisible}
        >
          <div className="pt2">
            <If condition={description}>
              <span
                className="lh-copy normal"
                style={{ color: COLORS.grayDark }}
              >
                {description}
              </span>
            </If>
            <div>
              <form onSubmit={handleSubmit}>
                <FieldsList
                  fields={fields}
                  formState={formState}
                  validateErrors={validateErrors}
                  onChange={handleFormChange}
                  initialData={initialData}
                  handleFieldOptions={handleFieldOptions}
                  customRoleOptions={customRoleOptions}
                />
                <div className="flex pt4">
                  <Button
                    type="submit"
                    raised
                    color="primary"
                    disabled={!isValid || loading}
                  >
                    {submitBtnText || formatMessage({ id: 'common.save' })}
                  </Button>
                  <Button
                    className="ml3"
                    color="accent"
                    onClick={onClose}
                    type="button"
                  >
                    {formatMessage({ id: 'common.cancel' })}
                  </Button>
                </div>
              </form>
            </div>
          </div>
        </Popup>
      )}
    </MediaQuery>
  );
};

SimpleFormPopup.defaultProps = {
  onSubmit: () => {},
  onChange: () => {},
};

SimpleFormPopup.propTypes = {
  loading: PropTypes.bool,
  onClose: PropTypes.func,
  onSubmit: PropTypes.func,
  onChange: PropTypes.func,
  title: PropTypes.string,
  description: PropTypes.string,
  errors: PropTypes.object,
  fields: PropTypes.array,
  validateFields: PropTypes.array,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
  }),
  submitBtnText: PropTypes.string,
  initialData: PropTypes.object,
  secondaryContentVisible: PropTypes.bool,
  handleFieldOptions: PropTypes.object,
  mobileFullScreen: PropTypes.bool,
  popupWidthType: PropTypes.string,
  strictClose: PropTypes.bool,
  customRoleOptions: PropTypes.array,
};

export default enhance(SimpleFormPopup);



// WEBPACK FOOTER //
// ./src/components/common/SimpleFormPopup/index.jsx